import React, { useContext, useEffect, useState } from "react";
import { RiArrowDownSFill, RiLoader2Fill } from "react-icons/ri";
import { IoIosSearch } from "react-icons/io";
import axios from "axios";
import Constant from "../Components/Utils/Constant";
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import app from "../Firebase";
import unitysceen from "../assests/images/unitysceen.png";
import { ToastContainer, toast } from "react-toastify";
import { contextProvider } from "../Components/Context";

export default function EditCategoryForm({ editPopup, setEditPopup }) {
  const [existModel, setExistModel] = useState(editPopup);
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedVideos, setSelectedVideos] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [companyname, setCompanyname] = useState("");
  const [category, setCategory] = useState("");
  const [which_type, setWhich_type] = useState("");
  const [access, setAccess] = useState([]);
  const [modelname, setModelname] = useState("");
  const [thumbnail, setThumbnail] = useState(undefined);
  const [model, setModel] = useState(undefined);
  const [thumbnailPerc, setThumbnailPerc] = useState(0);
  const [modelPerc, setModelPerc] = useState(0);
  const [isUnitySceneUploading, setIsUnitySceneUploading] = useState(false);
  const [unitySceneUploadProgress, setUnitySceneUploadProgress] = useState(0);
  const [inputs, setInputs] = useState({});
  const [showEditForm, setShowEditForm] = useState(false);
  const [isDropdownOpenfilter, setIsDropdownOpenfilter] = useState(false);
  const [user, setUser] = useState([]);
  const [totalCount1, setTotalCount1] = useState(null);
  const { totalCount, setTotalCount } = useContext(contextProvider);
  const [searchUserTerm, setSearchUserTerm] = useState("");
  const [filterUserData, setFilterUserData] = useState([]);
  const [searchCompanyTerm, setSearchCompanyTerm] = useState("");
  const [filterCompanyData, setFilterCompanyData] = useState([]);
  const [searchCategoryTerm, setSearchCategoryTerm] = useState("");
  const [filterCategoryData, setFilterCategoryData] = useState([]);
  const [userName, setUserName] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [customCategory, setCustomCategory] = useState("");
  const [uniqueCategories, setUniqueCategories] = useState([]);
  const [customCompanyname, setCustomCompanyname] = useState("");
  const [uniqueCompanynames, setUniqueCompanynames] = useState([]);
  const [dropdownOpenCompany, setDropdownOpenCompany] = useState(false);
  const [selectedItemCompany, setSelectedItemCompany] = useState(null);

  const handleModelTypeChange = (event) => {
    const selectedType = event.target.value;
    setWhich_type(selectedType);
  };

  //user get for email
  useEffect(() => {
    const storedName = localStorage.getItem("name");

    if (storedName) {
      setUserName(storedName);
    } else {
      setUserName("Unauthorized");
    }
    const fetchUser = async () => {
      try {
        const response = await fetch(`${Constant.BASE_URL}/user/get`);
        const data = await response.json();

        if (data && data.admins) {
          setUser(data.admins);
          if (data.success) {
            setTotalCount1(data.totalCount);
          }
        }

        setLoading(false);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };

    fetchUser();
  }, []);

  const handleCloseEdit = () => {
    setEditPopup(false);
  };
  // toggle dropdown
  const toggleDropdownfilter = () => {
    setIsDropdownOpenfilter(!isDropdownOpenfilter);
    setDropdownOpen(null);
    setDropdownOpenCompany(null);
  };



  // Checkbox state

  const [checkboxStates, setCheckboxStates] = useState([]);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  useEffect(() => {
    const userEmails = user.map(userObj => userObj.email);
    const initialCheckboxStates = userEmails.map(email => existModel.access.includes(email));
    setCheckboxStates(initialCheckboxStates);
    const initialAccess = userEmails.filter(email => existModel.access.includes(email));
    setAccess(initialAccess);

    console.log('Initial checkbox states:', initialCheckboxStates);
    console.log('Initial access:', initialAccess);
  }, [existModel, user, filterUserData]);

  const handleCheckboxChanged = (index) => {
    const newCheckboxStates = [...checkboxStates];
    newCheckboxStates[index] = !newCheckboxStates[index];
    setCheckboxStates(newCheckboxStates);

    const selectedAccess = user
      .filter((_, i) => newCheckboxStates[i])
      .map((item) => item.email);
    setAccess(selectedAccess);
  };

  // Function to handle "Select All" checkbox change
  const handleSelectAllChanged = () => {
    setSelectAllChecked(!selectAllChecked);
    setCheckboxStates(Array(user.length).fill(!selectAllChecked));

    // Update the access state based on selected checkboxes
    const selectedAccess = user
      .map((item, i) =>
        !selectAllChecked || checkboxStates[i] ? item.email : null
      )
      .filter(Boolean);
    setAccess(selectedAccess);
  };

  const countCheckedUsers = () => {
    const checkedCount = checkboxStates.filter((isChecked) => isChecked).length;
    return checkedCount;
  };


  // category selection functionalities
  useEffect(() => {
    const uniqueCategories = Array.from(
      new Set(videos.map((item) => item.category))
    );
    const uniqueCategoriesList = uniqueCategories.map((category, index) => ({
      id: index,
      category: category,
    }));
    setUniqueCategories(uniqueCategoriesList);
  }, [videos]);

  const handleDropdownToggle = () => {
    setDropdownOpen(!dropdownOpen);
    setIsDropdownOpenfilter(null)
    setDropdownOpenCompany(null);
    setFilterCategoryData([]);
  };

  const handleCategorySelect = (item) => {
    setSelectedItem(item);
    setCategory(item.category);
    setDropdownOpen(false);
  };

  const handleCustomCategoryAdd = () => {
    if (customCategory.trim() !== "") {
      const newCategory = {
        id: uniqueCategories.length,
        category: customCategory.trim(),
      };
      setUniqueCategories([...uniqueCategories, newCategory]);
      setSelectedItem(newCategory);
      setCategory(customCategory.trim());
      setDropdownOpen(false);
      setCustomCategory("");
    }
  };

  const handleCustomCategoryChange = (e) => {
    setCustomCategory(e.target.value);
  };

  // select company name dropdown
  useEffect(() => {
    const uniqueCompanyNames = Array.from(
      new Set(videos.map((item) => item.companyname))
    );
    const uniqueCompanynameList = uniqueCompanyNames.map(
      (companyname, index) => ({
        id: index,
        companyname: companyname,
      })
    );
    setUniqueCompanynames(uniqueCompanynameList);
  }, [videos]);

  const handleDropdownToggleCompanyname = () => {
    setDropdownOpenCompany(!dropdownOpenCompany);
    setDropdownOpen(null);
    setIsDropdownOpenfilter(null)
    setSearchCompanyTerm("");
    setFilterCompanyData([]);
  };

  const handleCompanyNameSelect = (item) => {
    setSelectedItemCompany(item);
    setCompanyname(item.companyname);
    setDropdownOpenCompany(false);
    setSearchCompanyTerm("");
  };

  const handleCustomCompanynameAdd = () => {
    if (customCompanyname.trim() !== "") {
      const newCompanyname = {
        id: uniqueCompanynames.length,
        companyname: customCompanyname.trim(),
      };
      setUniqueCompanynames([...uniqueCompanynames, newCompanyname]);
      setSelectedItemCompany(newCompanyname);
      setCompanyname(customCompanyname.trim());
      setDropdownOpenCompany(false);
      setSearchCompanyTerm("");
      setCustomCompanyname("");
    }
  };

  const handleCustomCompanynameChange = (e) => {
    setCustomCompanyname(e.target.value);
  };

  // get model data from the mongodb

  useEffect(() => {
    model && uploadFile(model, "modelUrl");
  }, [model]);

  useEffect(() => {
    thumbnail && uploadFile(thumbnail, "thumbnailUrl");
  }, [thumbnail]);

  const toggleVideoSelection = (videoId) => {
    if (selectedVideos.includes(videoId)) {
      setSelectedVideos(selectedVideos.filter((id) => id !== videoId));
    } else {
      setSelectedVideos([...selectedVideos, videoId]);
    }
  };

  //  uploading image and model to firebase
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size <= 200 * 1024) {
        setThumbnail(file);
        setModelname(file.name);
        setSelectedImage(URL.createObjectURL(file));
      } else {
        toast.error("Please select an image below 200 KB.");
      }
    }
  };

  const uploadFile = (file, fileType) => {
    const storage = getStorage(app);
    let folder;

    if (fileType === "thumbnailUrl") {
      folder = "thumbnail/";
    } else if (fileType === "modelUrl") {
      folder = "model/";
    } else if (fileType === "unitySceneUrl") {
      folder = "unityScene/";
    }

    const fileName = new Date().getTime() + file.name;
    const storageRef = ref(storage, folder + fileName);
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        if (fileType === "thumbnailUrl") {
          setThumbnailPerc(Math.round(progress));
        } else if (fileType === "modelUrl") {
          setModelPerc(Math.round(progress));
        } else if (fileType === "unitySceneUrl") {
          setUnitySceneUploadProgress(Math.round(progress));
        }
      },
      (error) => {
        console.log(error);
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          setInputs((prev) => {
            return {
              ...prev,
              [fileType]: downloadURL,
            };
          });
        });
      }
    );
  };

  const handleClear = () => {
    if (selectedImage === !null) {
      setSelectedImage(null);
    }
    if (model === !null) {
      setModel(null);
    }
  };

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const response = await fetch(`${Constant.BASE_URL}/model/get`);
        const data = await response.json();

        setVideos(data.videos);
        if (data.success) {
          setTotalCount(data.totalCount);
        }

        setLoading(false);
      } catch (error) {
        console.error("Error fetching videos:", error);
      }
    };

    fetchVideos();
  }, []);

  // post data to mongodb
  // const handleUpdate = async (e) => {
  //   e.preventDefault();

  //   try {
  //     if (
  //       category ||
  //       which_type ||
  //       companyname ||
  //       modelname ||
  //       inputs.modelUrl ||
  //       access ||
  //       inputs.thumbnailUrl
  //     ) {
  //       if (thumbnail && thumbnailPerc < 100) {
  //         toast.error("Wait for the image to upload");
  //         return;
  //       }
  //       if (model && unitySceneUploadProgress < 100) {
  //         toast.error("Wait for the model to upload");
  //         return;
  //       } else {
  //         const updateData = {};

  //         if (category) updateData.category = category;
  //         if (which_type) updateData.which_type = which_type;
  //         if (companyname) updateData.companyname = companyname;
  //         if (model?.name) updateData.modelname = model.name;
  //         if (inputs.modelUrl) updateData.model = inputs.modelUrl;
  //         if (access) updateData.access = access;
  //         if (inputs.thumbnailUrl) updateData.thumbnail = inputs.thumbnailUrl;


  //         const response = await axios.put(
  //           `${Constant.BASE_URL}/model/update-New/${editPopup._id}`,
  //           updateData
  //         );

  //         if (response.data.success) {
  //           toast.success("Unity Model updated Successfully");
  //           setEditPopup(false);
  //           setCategory("");
  //           setWhich_type("");
  //           setCompanyname("");
  //           setModelname("");
  //           setModel({});
  //           setAccess([]);
  //           setThumbnail();
  //           return;
  //         } else {
  //           console.log("Update failed:", response.data.error);
  //           return;
  //         }
  //       }
  //     }
  //     toast.error("Nothing to update");
  //     return;
  //   } catch (error) {
  //     console.error("Error updating:", error);
  //   }
  // };
  
const handleUpdate = async (e) => {
    e.preventDefault();

    try {
      // --- Get the token from where you stored it after login ---
      // This is just an example; get it from your state management, local storage, etc.
      const token = localStorage.getItem("token"); 

      if (!token) {
        toast.error("You are not logged in!");
        return;
      }
      // -----------------------------------------------------------

      if (
        category ||
        which_type ||
        companyname ||
        modelname ||
        inputs.modelUrl ||
        access ||
        inputs.thumbnailUrl
      ) {
        if (thumbnail && thumbnailPerc < 100) {
          toast.error("Wait for the image to upload");
          return;
        }
        if (model && unitySceneUploadProgress < 100) {
          toast.error("Wait for the model to upload");
          return;
        } else {
          const updateData = {};

          if (category) updateData.category = category;
          if (which_type) updateData.which_type = which_type;
          if (companyname) updateData.companyname = companyname;
          if (model?.name) updateData.modelname = model.name;
          if (inputs.modelUrl) updateData.model = inputs.modelUrl;
          if (access) updateData.access = access;
          if (inputs.thumbnailUrl) updateData.thumbnail = inputs.thumbnailUrl;

          // --- This is the corrected part ---
          const response = await axios.put(
            `${Constant.BASE_URL}/model/update-New/${editPopup._id}`, // Corrected URL from your previous code
            updateData,
            {
              headers: {
                Authorization: `Bearer ${token}`, // Add the token here
              },
            }
          );
          // ------------------------------------

          // Note: Your backend likely sends back a `message`, not `success`. Adjust if needed.
          if (response.data.message === "Model updated successfully") {
            toast.success("Unity Model updated Successfully");
            setEditPopup(false);
            setCategory("");
            setWhich_type("");
            setCompanyname("");
            setModelname("");
            setModel({});
            setAccess([]);
            setThumbnail();
            return;
          } else {
            console.log("Update failed:", response.data.error);
            return;
          }
        }
      }
      toast.error("Nothing to update");
      return;
    } catch (error) {
      console.error("Error updating:", error);
      // It's helpful to show the actual error from the backend
      toast.error(error.response?.data?.error || "An error occurred");
    }
  };
  const style = {
    width: `${unitySceneUploadProgress}%`,
    transition: "width 0.1s ease-in-out",
  };

  const style1 = {
    width: `${thumbnailPerc}%`,
    transition: "width 0.1s ease-in-out",
  };

  //user search
  const handleUserSearch = (e) => {
    const searchTerm = e.target.value.toLowerCase();
    setSearchUserTerm(searchTerm);

    const filteredData = user.filter((item) =>
      item.email.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilterUserData(filteredData);
  };

  // category search
  const handleCategorySearch = (e) => {
    const searchTerm = e.target.value.toLowerCase();
    setSearchCategoryTerm(searchTerm);

    const filteredCategories = uniqueCategories.filter((item) =>
      item.category.toLowerCase().includes(searchTerm)
    );
    setFilterCategoryData(filteredCategories);
  };

  const handleCompanySearch = (e) => {
    const searchTerm = e.target.value.toLowerCase();
    setSearchCompanyTerm(searchTerm);

    const filteredCompanyname = uniqueCompanynames.filter((item) =>
      item.companyname.toLowerCase().includes(searchTerm)
    );
    setFilterCompanyData(filteredCompanyname);
  };



  return (
    <div className="popup-formmodel">
      <div className="flex flex-col items-center justify-center px-10 py-6 bg-white rounded-md w-fit h-fit">
        <h1 className="text-lg font-semibold"> Edit Model</h1>
        <div className="h-[2px] w-full bg-[#959595] mt-0" />
        <form>
          <div className="flex flex-row items-center justify-between gap-16 px-4 mt-8">
            <div className="flex flex-col items-center gap-6">
              <div
                onDrop={(e) => handleImageChange(e)}
                className="flex-col w-40 h-40 bg-white rounded-md shadow-2xl"
              >
                <div className="flex flex-col justify-start mx-2 text-sm font-semibold">
                  <div className="pt-2 text-xs font-bold">Thumbnail :</div>
                  <div className="h-[1px] min-w-full bg-[#959595a0]" />
                </div>

                <div className="flex items-center mx-2 justify-center h-[110px]">
                  <label htmlFor="thumbnail" className="cursor-pointer">
                    {selectedImage ? (
                      <img
                        alt="upload"
                        src={selectedImage}
                        className="w-32 h-24"
                      />
                    ) : (
                      <img
                        alt="upload"
                        src={existModel.thumbnail}
                        className="w-32 h-24"
                      />
                    )}
                  </label>
                  <input
                    id="thumbnail"
                    type="file"
                    accept="image/*"
                    className="hidden"
                    onChange={(e) => {
                      handleImageChange(e);
                    }}
                    required
                  />
                </div>
                <div className="flex flex-col justify-end mx-2 text-sm font-semibold">
                  <div className="h-[2px] min-w-full bg-[#959595a0]" />
                  <div className="text-center text-[#959595a0] text-xs">
                    {thumbnail
                      ? thumbnail.name.length > 20
                        ? thumbnail.name.slice(0, 19) + "..."
                        : thumbnail.name
                      : ""}
                  </div>
                </div>
                {thumbnailPerc > 0 && (
                  <div className="w-full h-2">
                    <div
                      className="h-full rounded-b-md bg-opacity-70 bg-[#FFB257] transition-width duration-100 ease-in-out"
                      style={style1}
                    ></div>
                  </div>
                )}
              </div>
              <div className="flex-col w-40 h-40 bg-white rounded-md shadow-2xl">
                <div className="flex flex-col justify-start mx-2 text-sm font-semibold">
                  <div className="pt-2 text-xs font-bold">
                    Upload Model File :
                  </div>
                  <div className="h-[1px] min-w-full bg-[#959595a0]" />
                </div>
                <div className="flex mx-2 items-center justify-center h-[110px]">
                  <label htmlFor="model" className="cursor-pointer">
                    {model ? (
                      <img
                        alt="upload"
                        src={unitysceen}
                        className="w-16 h-16"
                      />
                    ) : (
                      <img
                        alt="upload"
                        src={unitysceen}
                        className="w-16 h-16"
                      />
                    )}
                  </label>
                  <input
                    className="hidden"
                    id="model"
                    type="file"
                    required
                    onChange={(e) => {
                      setIsUnitySceneUploading(true);
                      setUnitySceneUploadProgress(0);
                      setModel(e.target.files[0]);
                      uploadFile(e.target.files[0], "unitySceneUrl");
                    }}
                  />
                </div>

                <div className="flex flex-col justify-end mx-2 text-sm font-semibold">
                  <div className="h-[2px] min-w-full bg-[#959595a0]" />
                  <div className="text-center text-[#959595a0] text-xs">
                    {model
                      ? model.name.length > 20
                        ? model.name.slice(0, 19) + "..."
                        : model.name
                      : (existModel && existModel.modelname.slice(0, 19) + "...")}
                  </div>
                </div>
                {unitySceneUploadProgress > 0 && (
                  <div className="w-full h-2">
                    <div
                      className="h-full rounded-b-md bg-opacity-70 bg-[#FFB257] transition-width duration-100 ease-in-out"
                      style={style}
                    ></div>
                  </div>
                )}
              </div>
            </div>
            <div className="flex flex-col items-start gap-4">
              <div className="flex text-gray-500 items-center justify-end py-2 cursor-pointer">
                <label
                  htmlFor="yourInput"
                  className="flex text-gray-900 items-end px-3 font-semibold"
                >
                  Model name :
                </label>
                <input
                  disabled
                  value={model ? model.name : existModel.modelname}
                  type="text"
                  id="yourInput"
                  className="flex items-start mb-2 border-b border-gray-500 outline-none"
                  style={{ width: "163px", textAlign: "center" }}
                  placeholder="Super Admin (Auto)"
                />
              </div>
              <div className="flex  text-gray-500 items-center justify-end py-3 cursor-pointer">
                <label htmlFor="modelTypeSelect" className="flex text-gray-900 items-end px-3 font-semibold">
                  Model Type:<span className="ml-1 text-red-500">*</span>
                </label>
                <select
                  id="modelTypeSelect"
                  className="flex items-start mb-2 border-b border-gray-500 outline-none"
                  style={{ width: "163px", textAlign: "center" }}
                  value={which_type}
                  onChange={(e) => setWhich_type(e.target.value)}
                >
                  <option value="" disabled hidden>
                    {existModel.which_type} {/* Placeholder text */}
                  </option>
                  <option value="2D">2D</option>
                  <option value="3D">3D</option>
                </select>
              </div>
              <div className="relative flex items-center justify-start py-3 cursor-pointer">
                <label
                  htmlFor="yourInput"
                  className="flex items-end px-3 font-semibold"
                >
                  Category :<span className="ml-1 text-red-500">*</span>
                </label>
                <div className="flex pb-1 border-b border-gray-500 outline-none ">
                  <input
                    type="text"
                    value={category}
                    onChange={(e) => setCategory(e.target.value)}
                    placeholder={existModel.category}
                    style={{ border: "none", outline: "none", textAlign: "center" }}
                    required
                    disabled
                  />
                  <RiArrowDownSFill
                    onClick={handleDropdownToggle}
                    className="text-xl"
                  />
                  {dropdownOpen && (
                    <div
                      style={{
                        // borderRadius: "0 0 5px 5px",
                        border: "1px solid #0000000a",
                        zIndex: "100",
                      }}
                      className="lg:text-[10px] lg:w-fit xl:text-[15px] py-1 absolute top-9 left-25 bg-white shadow-xl rounded-md overflow-y-auto h-[350px] modelscroll"
                    >
                      <div className=" flex items-center justify-start pl-2 my-1 mx-1 rounded-[5px] text-black  bg-white shadow-md border border-black-300 border-opacity-60">
                        <IoIosSearch className="text-xl text-[#D2D2D2]" />
                        <input
                          type="text"
                          placeholder="Search..."
                          onChange={handleCategorySearch}
                          className="w-[100px] placeholder-[#D2D2D2] bg-transparent outline-none border-none px-2 text-md"
                        />
                      </div>
                      <div className="flex items-center justify-start pl-2 my-1 mx-1 rounded-[5px]  bg-white shadow-md">
                        <input
                          type="text"
                          value={customCategory}
                          onChange={handleCustomCategoryChange}
                          placeholder="Add custom category"
                          style={{ border: "none", outline: "none" }}
                        />
                        <button
                          className="px-2"
                          onClick={handleCustomCategoryAdd}
                        >
                          <span className="px-1 border border-grey-200 rounded-sm text-grey-500 text-[10px]"> Add</span>
                        </button>
                      </div>
                      {filterCategoryData?.length > 0
                        ? filterCategoryData.map((item, index) => (
                          <div
                            key={item.id}
                            className="px-4 py-1 cursor-pointer Z-10 hover:bg-white hover:w-full"
                            onClick={() => handleCategorySelect(item)}
                          >
                            {item.category}
                          </div>
                        ))
                        : uniqueCategories.map((item) => (
                          <div
                            key={item.id}
                            className="px-4 py-1 cursor-pointer Z-10 hover:bg-white hover:w-full"
                            onClick={() => handleCategorySelect(item)}
                          >
                            {item.category}
                          </div>
                        ))}
                    </div>
                  )}
                </div>
              </div>
              <div className="relative flex items-center justify-start py-3 cursor-pointer">
                <label
                  htmlFor="yourInput"
                  className="flex items-end px-3 font-semibold"
                >
                  Company Name :
                </label>
                <div className="flex pb-1 border-b border-gray-500 outline-none">
                  <input
                    type="text"
                    value={companyname}
                    onChange={(e) => setCompanyname(e.target.value)}
                    placeholder={existModel.companyname}
                    style={{ border: "none", outline: "none", textAlign: "center" }}
                    disabled
                  />
                  <RiArrowDownSFill
                    onClick={handleDropdownToggleCompanyname}
                    className="text-xl"
                  />
                  {dropdownOpenCompany && (
                    <div
                      style={{
                        border: "1px solid #0000000a",
                        zIndex: "100",
                      }}
                      className="lg:text-[10px] lg:w-fit xl:text-[15px] absolute top-9 left-25 bg-white shadow-xl rounded-md overflow-y-auto h-[280px] modelscroll"
                    >
                      <div className="flex items-center justify-start pl-2 my-1 mx-1 rounded-[5px] text-black bg-white shadow-md border border-black-300 border-opacity-60">
                        <IoIosSearch className="text-xl text-[#D2D2D2]" />
                        <input
                          type="text"
                          placeholder="Search..."
                          onChange={handleCompanySearch}
                          className="w-[100px] placeholder-[#D2D2D2] bg-transparent outline-none border-none px-2 text-md"
                        />
                      </div>
                      <div className="flex items-center justify-start pl-2 my-1 mx-1 rounded-[5px] text-black bg-white shadow-md">
                        <input
                          type="text"
                          value={customCompanyname}
                          onChange={handleCustomCompanynameChange}
                          placeholder="Add custom company"
                          style={{ border: "none", outline: "none" }}
                        />
                        <button
                          className="px-2"
                          onClick={handleCustomCompanynameAdd}
                        >
                          <span className="px-1 border border-grey-200 rounded-sm text-grey-500 text-[10px]"> Add</span>
                        </button>
                      </div>
                      {filterCompanyData?.length > 0
                        ? filterCompanyData.map((item, index) => (
                          <div
                            key={item.id}
                            className="px-4 py-1 cursor-pointer Z-10 hover:bg-white hover:w-full"
                            onClick={() => handleCompanyNameSelect(item)}
                          >
                            {item.companyname}
                          </div>
                        ))
                        : uniqueCompanynames.map((item) => (
                          <div
                            key={item.id}
                            className="px-4 py-1 cursor-pointer Z-10 hover:bg-white hover:w-full"
                            onClick={() => handleCompanyNameSelect(item)}
                          >
                            {item.companyname}
                          </div>
                        ))}
                    </div>
                  )}
                </div>
              </div>

              <div className="relative flex items-center justify-end py-3 cursor-pointer">
                <label
                  htmlFor="yourInput"
                  className="flex items-end px-3 font-semibold"
                >
                  Model Assign to :
                </label>
                <div
                  className="flex items-start mb-2 text-gray-500 pb-1 text-black border-b border-gray-500 outline-none"
                  style={{ width: "163px", textAlign: "center" }}
                >
                  <p style={{ alignItems: "center", textAlign: "center" }}>{countCheckedUsers()} selected
                    {" " + user?.length}</p>
                </div>{" "}
                <div
                  onClick={toggleDropdownfilter}
                  className="absolute bottom-6 right-1 flex justify-center items-center p-[0.2px] bg-[#ffffff] shadow-black shadow-sm rounded-md"
                >
                  <RiArrowDownSFill className="text-xl" />
                </div>
                {isDropdownOpenfilter && (
                  <div
                    style={{
                      border: "1px solid #0000000a",
                      zIndex: "100",
                    }}
                    className="lg:text-[10px] lg:w-fit xl:text-[15px] absolute top-9 left-36 bg-white shadow-xl rounded-md "
                  >
                    {/* Dropdown Options */}
                    <ul className="overflow-y-auto h-[190px] modelscroll py-2">
                      <li className="flex items-center justify-center ">
                        <div className="w-full flex items-center justify-start pl-2 my-1 mx-1 rounded-[5px] text-black bg-white shadow-md border border-black-300 border-opacity-60">
                          <IoIosSearch className="text-xl text-[#D2D2D2]" />
                          <input
                            type="text"
                            placeholder="Search..."
                            onChange={handleUserSearch}
                            className="w-[100px] placeholder-[#D2D2D2] bg-transparent outline-none border-none px-2 text-md"
                          />
                        </div>
                      </li>
                      {/* "Select All" checkbox */}
                      <li className="flex items-center justify-between px-2 py-1 text-black border-t cursor-pointer">
                        <span className="text-[12px]">All</span>
                        <div className="flex items-center justify-end">
                          <label className="inline-flex items-center">
                            <div
                              className={`w-4 h-4 bg-white shadow-md border-red-500 rounded-sm flex items-center justify-center ml-2 ${selectAllChecked ? "bg-red-500" : ""
                                }`}
                            >
                              {selectAllChecked && (
                                <div className="w-2 h-2 bg-red-500"></div>
                              )}
                            </div>
                            <input
                              className="hidden"
                              type="checkbox"
                              checked={selectAllChecked}
                              onChange={handleSelectAllChanged}
                            />
                          </label>
                        </div>
                      </li>

                      {filterUserData?.length > 0
                        ? filterUserData.map((item, index) => (
                          <div
                            key={item.id}
                            className="flex items-center justify-between px-2 py-1 text-black border-t border-[#A8A8A8] cursor-pointer"
                          >
                            <span className="text-[12px]">
                              {item.email}
                            </span>
                            <div className="flex items-center">
                              <label className="inline-flex items-center">
                                <div
                                  className={`w-4 h-4 bg-white  shadow-md border-red-500 rounded-sm flex items-center justify-center ml-2 ${checkboxStates[index]
                                    ? "bg-red-500"
                                    : ""
                                    }`}
                                >
                                  {checkboxStates[index] && (
                                    <div className="w-2 h-2 bg-red-500"></div>
                                  )}
                                </div>
                                <input
                                  className="hidden"
                                  type="checkbox"
                                  // value={existModel.email}
                                  checked={checkboxStates[index] || Array.isArray(existModel.access) ? [...existModel.access].includes(item.email) : []}
                                  onChange={() =>
                                    handleCheckboxChanged(index)
                                  }
                                />
                              </label>
                            </div>
                          </div>
                        ))
                        : user.map((item, index) => (
                          <div
                            key={item.id}
                            className="flex items-center justify-between px-2 py-1 text-black border-t border-[#A8A8A8] cursor-pointer"
                          >
                            <span className="text-[12px]">
                              {item.email}

                            </span>
                            <div className="flex items-center">
                              <label className="inline-flex items-center">
                                <div
                                  className={`w-4 h-4 bg-white border border-black-300 shadow-lg  rounded-sm flex items-center justify-center ml-2 ${checkboxStates[index]
                                    ? "bg-red-500"
                                    : ""
                                    }`}
                                >
                                  {checkboxStates[index] && (
                                    <div className="w-2 h-2 bg-red-500"></div>
                                  )}
                                </div>
                                <input
                                  className="hidden"
                                  type="checkbox"
                                  checked={checkboxStates[index]}
                                  onChange={() =>
                                    handleCheckboxChanged(index)
                                  }
                                />
                              </label>
                            </div>
                          </div>
                        ))}
                    </ul>
                    <button
                      className="flex justify-center w-full bg-white item-center rouded-md py-1"
                      onClick={toggleDropdownfilter}
                    >
                      Apply
                    </button>
                  </div>
                )}
              </div>
              <div className="flex text-gray-500 items-center justify-end py-3 cursor-pointer">
                <label
                  htmlFor="yourInput"
                  className="flex text-gray-900 items-end px-3 font-semibold"
                >
                  Uploaded By :
                </label>
                <input
                  disabled
                  value={existModel.createdby}
                  type="text"
                  id="yourInput"
                  className="flex items-start mb-2 border-b border-gray-500 outline-none"
                  style={{ width: "163px", textAlign: "center" }}
                  placeholder={existModel.createdby}
                />
              </div>
            </div>
          </div>
          <div className="flex justify-center p-1 mt-1 space-x-12 button-container pt-5">
            <button
              type="button"
              onClick={handleCloseEdit}
              className="flex-shrink-0 w-16 text-black bg-white shadow-md loginbtn rounded-sm"
              style={{
                background: "(.white.opacity(0.57))",
              }}
            >
              Cancel
            </button>

            <button
              onClick={handleUpdate}
              className={`loginbtn text w-16 flex-shrink-0 bg-custom-gradient rounded-sm
                        }`}
              style={{
                background:
                  "radial-gradient(125% 125% at 85.42% 0%, #FFD6A6 0%, #FF9C28 100%)",
              }}
            >
              update
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}